import axios, { getData } from 'lib/axios'

//fetching parameters of specific single evaluation
export const getEvaluation = (evalId) => {
  return axios.get(`/admin/evaluations/${evalId}`).then(getData)
}

export const getAllEvaluation = () => {
  return axios.get('/admin/evaluations').then(getData)
}

export const createEvaluation = (data) => {
  return axios.post('/admin/evaluations', data).then(getData)
}

export const saveEvaluation = ({ evaluationId, data }) => {
  return axios.put(`/admin/evaluations/${evaluationId}`, data).then(getData)
}

export const deleteEvaluation = (evalId) => {
  return axios.delete(`/admin/evaluations/${evalId}`).then(getData)
}

export const duplicateEvaluation = (evalId) => {
  return axios.post(`/admin/evaluations/duplicate/${evalId}`).then(getData)
}
